import { SocketService } from './socketService.js'
import { apiBaseUrl } from '../../const'

const wsUrl = apiBaseUrl.replace(/^https/, 'wss')
const socketService = new SocketService(wsUrl)

export default socketService
